/**
 * Conges Dashboard Query Keys
 *
 * Centralized query key factory for conges dashboard.
 */

export const congesDashboardQueryKeys = {
  all: ["conges-dashboard"] as const,
  summary: () => [...congesDashboardQueryKeys.all, "summary"] as const,
} as const;
